// import Pdf from './documents/Oneeb_CV.pdf';
import {Document, Page} from 'react-pdf';
import { useState } from 'react';
const CV_Resume = () => {
	const [isLoading, setLoadingHidden] = useState(true)

	function hideSpinner(e) {
		setLoadingHidden(false);
	}

	return (
		<div className="cv_resume" align="center">
			{isLoading ? (
			<div class="d-flex justify-content-center">
				<div class="spinner-border text-primary" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
			) : null }
				
			<iframe onLoad={hideSpinner} src="https://drive.google.com/file/d/1r_MfAU2jrCwoWcbhkCMSrd0yrhQqF35k/preview" width="150%" height="800px" allow="autoplay"></iframe>
			
		</div>
	);
}

export default CV_Resume;

// class Rsvp extends React.Component {
// 	constructor(props) {  
// 	  super(props);
// 	  this.state = {
// 		loading: true
// 	  };
// 	}
  
//   hideSpinner = () => {
// 	  this.setState({
// 		loading: false
// 	  });
// 	};
  
//   render() {
// 	  return (
// 		<div className="container rsvp-wrapper">
// 		  {this.state.loading ? (
// 			<Spinner
// 			  className="loading text-center"
// 			  name="three-bounce"
// 			  color="white"
// 			  fadeIn="none"
// 			/>
// 		  ) : null}
  
// 		  <iframe
// 			src="..."
// 			width="100%"
// 			height="700"
// 			onLoad={this.hideSpinner}
// 			frameBorder="0"
// 			marginHeight="0"
// 			marginWidth="0"
// 		  />
// 		</div>
// 	  );
// 	}
//   }